import React from 'react';
import cx from 'classnames';
import styles from './socialLink.css';
import * as icons from 'components/modules/Icons';

const iconsMap = {
  facebook: icons.facebook,
  youtube: icons.youtube,
  instagram: icons.insta,
};

const SocialLink = ({ title, href, className }) => {
  const Icon = iconsMap[title];
  return (
    <a href={href} target="_blank" className={cx(styles.root, className)}>
      <span className={styles.hidden}>{title}</span>
      <Icon className={styles.icon} />
    </a>
  );
};

export default SocialLink;



// WEBPACK FOOTER //
// ./src/components/modules/SocialLink/SocialLink.js